import { MaybeRef } from 'vue';
import vtkPolyData from '@kitware/vtk.js/Common/DataModel/PolyData';
// import vtkImageData from '@kitware/vtk.js/Common/DataModel/ImageData';
import { useVtkRepresentation } from '@/src/core/vtk/useVtkRepresentation';
import { Maybe } from '@/src/types';
import { View } from '@/src/core/vtk/types';
// import vtkVolume from '@kitware/vtk.js/Rendering/Core/Volume';
// import vtkVolumeMapper from '@kitware/vtk.js/Rendering/Core/VolumeMapper';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';

export function usePolydataRepresentation(
  view: View,
  polyData: MaybeRef<Maybe<vtkPolyData>>
) {
  const polyRep = useVtkRepresentation({
    view,
    data: polyData,
    vtkActorClass: vtkActor,
    vtkMapperClass: vtkMapper,
  });

  return polyRep;
}
